import h from 'hyperscript';
import getVideoId from 'get-video-id';
import plyr from 'plyr';
import Cookies from 'js-cookie';
import Overlay from '../../../javascripts/utils/overlay';

const getStart = (url) => {
  const params = new URLSearchParams(url.split('?')[1]);
  return params.get('start');
};

// Internal videos
plyr.setup(document.querySelectorAll('.figure__video'), {
  loadSprite: false,
  i18n: {
    restart: 'Neustarten',
    rewind: '{seektime} Sekunden zurückspulen',
    play: 'Abspielen',
    pause: 'Pausieren',
    forward: '{seektime} Sekunden vorspulen',
    buffered: 'vorgeladen',
    currentTime: 'Aktuelle Abspielzeit',
    duration: 'Länge',
    volume: 'Lautstärke',
    toggleMute: 'Ton an-/abschalten',
    toggleCaptions: 'Untertitel an-/abschalten',
    toggleFullscreen: 'Vollbild an-/abschalten',
  },
  iconPrefix: 'icon',
  controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen'],
});

const initializeIframe = ({ url, withCookie, container }) => {
  const isVideoLoadedBefore = container.querySelector('.figure__video-wrapper');
  const { id, service } = getVideoId(url);
  const start = getStart(url);
  let $iframeContent = null;

  // Construct Youtube iframe player, add rel=0 to disable related videos
  if (id && service === 'youtube') {
    $iframeContent = h(
      '.figure__video-wrapper',
      h('iframe.figure__video-iframe', {
        src: `https://www.youtube${withCookie ? '' : '-nocookie'}.com/embed/${id}?rel=0&autoplay=1&start=${start || 0}`,
        allowFullscreen: true,
        msAllowFullscreen: true,
        webkitAllowFullscreen: true,
        mozAllowFullscreen: true,
      }),
    );
  }

  // Construct Vimeo iframe player
  if (id && service === 'vimeo') {
    $iframeContent = h(
      '.figure__video-wrapper',
      h('iframe.figure__video-iframe', {
        src: `https://player.vimeo.com/video/${id}`,
        allowFullscreen: true,
        msAllowFullscreen: true,
        webkitAllowFullscreen: true,
        mozAllowFullscreen: true,
      }),
    );
  }

  if (!isVideoLoadedBefore && $iframeContent) {
    container.appendChild($iframeContent, container);
  }
};

class Figure {
  constructor($el, config) {
    this.config = {
      wrapperClass: 'figure__media',
      playLinkClass: 'figure__play',
      ...config,
    };
    // Elements
    this.$el = $el;
    this.$figure = $el.querySelector(`.${this.config.wrapperClass}`);
    this.$playLink = $el.querySelector(`.${this.config.playLinkClass}`);
    this.$videoPlay = this.$el.querySelector('.figure__play');
    this.$videoOverlay = this.$el.querySelector('.figure__overlay');
    this.$copyright = this.$el.querySelector('.figure__copyright');
    this.cookieName = this.$el.getAttribute('data-cookie');

    this.Overlay = new Overlay({
      onOverlayInit: this.onInitOverlay,
      onDecline: this.onDeclineConsent,
      onConsent: this.onConsent,
      onGlobalConsent: this.onGlobalConsent,
      consentCookieName: this.cookieName,
      providerName: $el.getAttribute('data-provider'),
      $el: this.$el,
    });


    if (this.$playLink) {
      this.checkForCookie();
      this.$playLink.addEventListener('click', this.playVideo);
    }
  }

  checkForCookie = () => {
    const { service } = getVideoId(this.$playLink.href);
    const neededCookie = Cookies.get(`bawu-${service}`) || null;

    if (neededCookie && neededCookie === 'accept') {
      this.$figure.classList.remove('figure__cookie-overlay-active');
      this.Overlay.destroy();
    }
  }

  playVideo = (event) => {
    const { service } = getVideoId(this.$playLink.href);
    const neededCookie = Cookies.get(`bawu-${service}`) || null;

    event.preventDefault();
    event.stopPropagation();

    if (!neededCookie && neededCookie !== 'accept') {
      // Init overlay only if not active yet
      if (!this.$figure.classList.contains('figure__cookie-overlay-active')) {
        this.Overlay.init();
        this.$figure.classList.add('figure__cookie-overlay-active');
      }
    } else {
      this.onConsent();
    }
  }

  onConsent = () => {
    this.$figure.classList.remove('figure__cookie-overlay-active');
    this.$figure.classList.add('figure__cookie-consent');
    this.Overlay.destroy();

    initializeIframe({
      url: this.$playLink.href,
      container: this.$figure,
      withCookie: false,
    });
  }

  onGlobalConsent = () => {
    initializeIframe({
      url: this.$playLink.href,
      container: this.$figure,
      withCookie: true,
    });

    this.Overlay.destroy();
  }

  deconstructor() {
    this.Overlay.destroy();
  }
}

// external Video
let componentStore = [];

export default function initFigure() {
  componentStore.forEach(component => component.deconstructor && component.deconstructor());
  componentStore = [];

  document
    .querySelectorAll('.js-figure')
    .forEach(($figure) => {
      componentStore.push(new Figure($figure, {}));
    });
}

initFigure();
